import React from 'react';
import { Link } from 'react-router-dom';

const AttentionPanel = ({ alerts }) => {
    // Silence Policy: If no alerts, return null (Don't show "All OK")
    if (!alerts || alerts.length === 0) return null;

    return (
        <div className="section">
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                <span style={{ fontSize: '18px', marginRight: '8px' }}>⚠️</span>
                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 'bold', color: 'var(--charcoal)' }}>NEEDS YOUR ATTENTION</h3>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {alerts.map((alert, index) => (
                    <div key={index} style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '12px 16px',
                        backgroundColor: alert.type === 'success' ? 'var(--success-bg)' : (alert.type === 'danger' ? 'var(--danger-bg)' : 'var(--warning-bg)'),
                        borderRadius: '8px',
                        borderLeft: `4px solid ${alert.type === 'success' ? 'var(--success)' : (alert.type === 'danger' ? 'var(--danger)' : 'var(--warning)')}`
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <span style={{ fontSize: '18px' }}>
                                {alert.type === 'success' ? '✅' : (alert.type === 'danger' ? '🚨' : '⚠️')}
                            </span>
                            <span style={{
                                color: alert.type === 'success' ? 'var(--success)' : (alert.type === 'danger' ? 'var(--danger)' : 'var(--warning)'),
                                fontWeight: '600',
                                fontSize: '14px'
                            }}>
                                {alert.text}
                            </span>
                        </div>
                        <Link to={alert.link} className='btn' style={{
                            padding: '6px 12px',
                            fontSize: '12px',
                            background: 'white',
                            color: 'var(--text-primary)',
                            boxShadow: 'var(--shadow-sm)',
                            textDecoration: 'none'
                        }}>
                            {alert.actionText}
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AttentionPanel;
